import ThemeSwitch from "../../appearance/ThemeSwitch";
import { signOut } from "../../auth/services/signOut";
import { useAuthContext } from "../../auth/state/AuthContext";
import { themeAtom } from "../atoms";
import { CustomHeader } from "./CustomHeader";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { useAtomValue } from "jotai";
import { useNavigate, useLocation } from "react-router-dom";
import { twMerge } from "tailwind-merge";

const Header = () => {
  const theme = useAtomValue(themeAtom);

  const navigate = useNavigate();
  const location = useLocation();
  const { firstname, lastname, sub: email } = useAuthContext().state.user?.accessToken || {};
  const user = {
    name: `${firstname} ${lastname}`,
    email: email ?? "",
    profileImage: "path/to/profile-image.jpg",
    company: {
      name: "Company XYZ",
      logoUrl: "path/to/company-logo.png",
    },
  };

  const navigation = [{ name: "Logout", path: "/", callback: signOut, requiresConfirmation: true }];

  const shouldHideBackBtn = ["/landingPage", "/missing-documents"].includes(`${location.pathname}`);

  return (
    <div>
      <div className="flex justify-between">
        {shouldHideBackBtn ? (
          <div />
        ) : (
          <button
            onClick={() => navigate(-1)}
            className={twMerge(
              "flex flex-shrink-0 items-center rounded-lg border px-2 py-2 text-sm focus:outline-none",
              theme.headerComponent.tailwind.buttonBorder,
              theme.headerComponent.tailwind.buttonHoverBg,
              theme.headerComponent.tailwind.buttonHoverText,
              theme.headerComponent.tailwind.buttonText,
              theme.headerComponent.tailwind.backButtonBg,
            )}
            style={{ width: "90px", height: "36px" }}
          >
            <ArrowLeftIcon className="mr-2 h-4 w-4" />
            Back
          </button>
        )}

        <div data-testid="techform-header-user-controls" className="flex items-center">
          <ThemeSwitch userEmail={email} />
          <CustomHeader user={user} navigation={navigation} />
        </div>
      </div>
    </div>
  );
};

export default Header;
